import React, { useEffect, useState } from 'react';
import {Link} from "react-router-dom";
import { Formik } from 'formik';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import RadioGroup from '../../components/RadioGroup'
import Select from '../../components/Select'
import HeaderLogo from '../../components/HeaderLogo'
import TextField from '../../components/TextField';
import Checkbox from '../../components/Checkbox';
import Button from '../../components/Button';

import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputAdornment from '@material-ui/core/InputAdornment';

const QuestionForm = ({options, details, setDetails}) => {
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const formik = useFormik({
      initialValues: {
        tilesSize: details?.tilesSize===''?'nodata':details?.tilesSize||'', 
        areaSize: details?.areaSize||'', 
        sparePercent: details?.sparePercent||'0',
        unknowAreaSize: details?.unknowAreaSize||false,
        areaType: details?.areaType||'',
        room: details?.room||'',
        floor: details?.floor||'',
      },
      validationSchema: Yup.object({
        tilesSize: Yup.string()
        .required('* จำเป็นต้องกรอก'),
        areaSize: Yup.string()
        .required('* จำเป็นต้องกรอก'),
        areaType: Yup.string()
        .required(' * จำเป็นต้องกรอก'),
        sparePercent: Yup.string()
        .required('* จำเป็นต้องกรอก'),
        room: Yup.string()
        .required(' * จำเป็นต้องกรอก'),
        floor: Yup.string()
        .required(' * จำเป็นต้องกรอก'),
      }),
      onSubmit: values => {
        let tempDetails = {
            tilesSize: values.tilesSize==="nodata"?"":values.tilesSize, 
            areaSize: values.unknowAreaSize?"nodata":values.areaSize, 
            sparePercent: values.unknowAreaSize?"":values.sparePercent,
            unknowAreaSize: values.unknowAreaSize,
            areaType: values.areaType,
            room: values.room,
            floor: values.floor 
        }
        if(tempDetails.areaSize < 10 && !tempDetails.unknowAreaSize && !open3){
            handleOpen3()
        }
        else{
            setDetails(tempDetails)
        }
      },
    });

    function nodataSelected(e, effectedField){
        formik.handleChange(e)
        if(e.target.checked){
            formik.setFieldValue('areaSize', 'nodata')
        }
        // formik.setFieldValue(effectedField, 'nodata')
        // formik.values[effectedField] = 'nodata'
    }
    function handleNumberChange(e){
        if(e.target.value > 99) e.target.value = 99
        formik.handleChange(e)
    }
    function floorLimit(e, limit){
        if(e.target.value < limit) e.target.value = 10
        formik.handleChange(e)
    }
    const handleOpen1 = () => {
        setOpen1(true);
    };
    const handleClose1 = () => {
        setOpen1(false);
    };
    const handleOpen2 = () => {
        setOpen2(true);
    };
    const handleClose2 = () => {
        setOpen2(false);
    };
    const handleOpen3 = () => {
        setOpen3(true);
    };
    const handleClose3 = () => {
        setOpen3(false);
    };
    return (
      <form onSubmit={formik.handleSubmit}>
        <Modal
          open={open1}
          onClose={handleClose1}
        >
          <div className='contact-modal'>
            <div className="h1 bold">เทียบไซส์กระเบื้อง?</div>
            <div className="flex row">
                <div style={{flex:1}}>
                    <img src="/asset/เทียบไซส์กระเบื้อง.png" style={{width: '100%'}} />
                </div>
                <div style={{flex:1, padding: '10px'}}>
                    <div className="h5 bold">*คำแนะนำ</div>
                    <div className="h5">สำหรับห้องที่มีขนาดเล็ก ควรเลือกใช้กระเบื้องขนาดเล็กเพื่อให้ห้องดูกว้างขึ้น</div>
                    <div className="h5"><br/>Tiles selected by</div>
                    <div className="flex row">
                        <img src="/asset/grandhomelogo.png" style={{width: '50px', height: '50px'}} />
                        <img src="/asset/duragres.png" style={{width: '50px', height: '50px'}} />
                    </div>
                </div>
            </div>
            <div className="floating-kay" style={{bottom: 0, top: 'unset'}}>
                <img className="kay-container" src="/asset/kay.png" />
            </div>
            <div 
            className="close-modal-container red-text h1 bold"
            onClick={handleClose1}
            >
                <CloseIcon/>
            </div>
          </div>
        </Modal>
        <Modal
          open={open2}
          onClose={handleClose2}
        >
          <div className='contact-modal'>
            <div className="h1 bold">วัดขนาดพื้นที่ปูกระเบื้องอย่างไร?</div>
            <div className="h5 bold">คำนวณพื้นที่ทั้งหมดจากการแบ่งพื้นที่ออกเป็นส่วนๆ</div>
            <div className="h5">แบ่งพื้นที่ห้องออกเป็นสี่เหลี่ยมจากนั้นระบุความกว้างและความยาวของแต่ละพื้นที่</div>
            <img src="/asset/คำนวณพื้นที่ปูกระเบื้อง.png" style={{width: '100%'}} />
            <div className="h5 bold">พื้นที่ปูกระเบื้องทั้งหมด = พื้นที่ A + พื้นที่ B</div>
            <div className="h5">
                พื้นที่ A = 3 x 4 = 12 sq.m.<br/>
                พื้นที่ B = 1 x 2 = 2 sq.m.<br/>
                รวมพื้นที่ทั้งหมด = 12 + 2 = 14 sq.m.
            </div>
            <div className="floating-kay" style={{bottom: 0, top: 'unset'}}>
                <img className="kay-container" src="/asset/kay.png" />
            </div>
            <div 
            className="close-modal-container red-text h1 bold"
            onClick={handleClose2}
            >
                <CloseIcon/>
            </div>
          </div>
        </Modal>
        <Modal
          open={open3}
          onClose={handleClose3}
        >
          <div className='contact-modal alert-modal'>
            <div className='inner-modal'>
                <div className="h2 bold green-text">*พื้นที่ปูกระเบื้องขั้นต่ำ 10 ตร.ม.</div>
                <div className="h5">
                    กรณีพื้นที่ขนาดต่ำกว่า 10 ตร.ม. จะคำนวณค่าบริการเป็น 10 ตร.ม. ทันที
                </div>
                <div className="h4"><br/></div>
                <div className="flex" style={{justifyContent: 'center', marginBottom: '5%'}}>
                <Button 
                style={{padding: '0 20px', border: '0', borderRadius: '10px'}}
                text={'ตกลง'} 
                bigText={true}
                onPress={formik.submitForm}
                />
                </div>
            </div>
            <div className="floating-kay bottom-kay">
                <img className="kay-container" src="/asset/kay_float.png" />
            </div>
          </div>
        </Modal>
        <div className="mainpadding">
            <div className="h2 bold alight-left flex row">
                <span className="green-text" style={{flex:1}}>1. ขนาดกระเบื้อง</span>
                <span className="modal-link h3" onClick={handleOpen1}>เทียบไซส์กระเบื้อง?</span>
            </div>
            <div className="h6"><br/></div>
            {/* <RadioGroup 
            name="tilesSize" 
            value={formik.values.tilesSize} 
            onChange={formik.handleChange} 
            options={options?.tilesSize} 
            /> */}
            <Select
            name="tilesSize"
            value={formik.values.tilesSize}
            onChange={formik.handleChange}
            options={options?.tilesSize}
            defaultValue="เลือกขนาดกระเบื้อง"
            style={{width: '70%'}}
            />
            {
                formik.errors.tilesSize && formik.touched.tilesSize ? (
                    <div className="alight-left bold red-text">{formik.errors.tilesSize}</div>
                ) : null
            }
        </div>
        <div className="mainpadding alight-left">
            <div className="h2 bold alight-left flex row">
                <span className="green-text" style={{flex:1}}>2. ขนาดพื้นที่ปูกระเบื้อง</span>
                <span className="modal-link h3" onClick={handleOpen2}>วัดอย่างไร?</span>
            </div>
            <div className="h6 red-text alight-left">*พื้นที่ขั้นต่ำ 10 ตร.ม.</div>
            <div className="h6"><br/></div>
            <TextField 
            id="areaSize"
            name="areaSize" 
            variant="outlined" 
            // type="number"
            size="small" 
            disabled={formik.values.unknowAreaSize}
            type={formik.values.unknowAreaSize?'text':'number'}
            value={!formik.values.unknowAreaSize?formik.values.areaSize:'ไม่ทราบ'}
            onChange={formik.handleChange}
            InputProps={{
                endAdornment: <InputAdornment position="end">ตร.ม.</InputAdornment>,
            }}
            />
            {
                formik.errors.areaSize && formik.touched.areaSize ? (
                    <div className="alight-left bold red-text">{formik.errors.areaSize}</div>
                ) : null
            }
            <div className="h6"><br/></div>
            {/* <div className="question-row-wrapper flex row">
                <div className="question-row-label">สำรองเผื่อการติดตั้ง</div>
                <TextField 
                name="sparePercent" 
                variant="outlined" 
                size="small" 
                disabled={formik.values.unknowAreaSize}
                type={'number'}
                value={!formik.values.unknowAreaSize?formik.values.sparePercent:0}
                onChange={handleNumberChange}
                InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                style={{width: '20%'}}
                />
                {
                    formik.errors.sparePercent && formik.touched.sparePercent ? (
                        <div className="alight-left bold red-text">{formik.errors.sparePercent}</div>
                    ) : null
                }
            </div> */}
            <FormControlLabel
            control={
                <Checkbox 
                id="unknowAreaSize" 
                name="unknowAreaSize" 
                checked={formik.values.unknowAreaSize} 
                onChange={(e)=>nodataSelected(e, 'areaSize')} 
                />
            }
            label={<span className="default-label">ไม่ทราบขนาดพื้นที่</span>}
            />
        </div>
        <div className="mainpadding alight-left">
            <div className="h2 bold green-text alight-left">3. บริเวณที่ปูกระเบื้อง</div>
            <div className="h6"><br/></div>
            <div className="question-row-wrapper flex row">
                <div className="question-row-label">บริเวณ </div>
                <Select
                name="areaType"
                value={formik.values.areaType}
                onChange={formik.handleChange}
                options={options?.areaType}
                defaultValue="เลือกบริเวณ"
                style={{width: '40%'}}
                />
                {
                    formik.errors.areaType && formik.touched.areaType ? (
                        <div className="alight-left bold red-text">{formik.errors.areaType}</div>
                    ) : null
                }
            </div>
            <div className="h6"><br/></div>
            <div className="question-row-wrapper flex row">
                <div className="question-row-label">ห้อง </div>
                <Select
                name="room"
                value={formik.values.room}
                onChange={formik.handleChange}
                options={options?.room}
                defaultValue="เลือกห้อง"
                style={{width: '40%'}}
                />
                {
                    formik.errors.room && formik.touched.room ? (
                        <div className="alight-left bold red-text">{formik.errors.room}</div>
                    ) : null
                }
            </div>
            <div className="h6"><br/></div>
            <div className="question-row-wrapper flex row">
                <div className="question-row-label">ชั้นที่ </div>
                <Select
                name="floor"
                value={formik.values.floor}
                onChange={formik.handleChange}
                options={options?.floor}
                defaultValue="เลือกชั้น"
                style={{width: '40%'}}
                />
                {
                    formik.errors.floor && formik.touched.floor ? (
                        <div className="alight-left bold red-text">{formik.errors.floor}</div>
                    ) : null
                }
            </div>
            {
                formik.values.floor === "upperflr_nolift"
                ?<div className="h6 red-text alight-left">
                    <br/>*กรณีหน้างานอยู่สูงกว่าชั้นที่ 1<br/>อาจมีค่าดำเนินการขนย้ายเพิ่มเติม (ประเมินราคาหน้างาน)
                </div>
                :null
            }
        </div>
        <Button 
        fullWidth 
        text={'เลือกบริการ >'} 
        type="submit"
        bigText={true}
        style={{
            position: 'fixed',
            left: '50%',
            bottom: 0,
            maxWidth: '500px',
            transform: 'translate(-50%, 0)'
        }}
        />
      </form>
    );
};

function WithtileQuestionPage({options, details, setDetails}) {
  return (
    <div className="page-container">
        {/* <HeaderLogo /> */}
        <div className="flex row mainpadding">
            <Link to="/" className="back-button">
                <div>{'< กลับ'}</div>
            </Link>
            <div className="bread-crump">
                <span className="h5 grey-text semibold">
                    <span className="green-text">รายละเอียด</span> / เลือกบริการ / สรุปข้อมูล
                </span>
            </div>
        </div>
        {/* <div className="cover-title-card box-shadow">
            <div className="cover-header-container red-bg box-shadow h3">หาช่างอย่างเดียว</div>        
        </div> */}
        <div>
            <QuestionForm options={options} details={details} setDetails={setDetails} />
        </div>
    </div>
  );
}

export default WithtileQuestionPage;
